import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const assignmentApi = createApi({
  reducerPath: "assignment",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/assignments" }),
  tagTypes: ["Assignment"],
  endpoints: (builder) => ({
    // 🧾 Create a new assignment
    createAssignment: builder.mutation({
      query: (formData) => ({
        url: "/create",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Assignment"],
    }),

    // 📥 Get all assignments
    getAssignments: builder.query({
      query: ({ batchCode, type, status }) => ({
        url: `/?batchCode=${batchCode || ""}${type ? `&type=${type}` : ""}${
          status ? `&status=${status}` : ""
        }`,
        method: "GET",
      }),
      providesTags: ["Assignment"],
    }),

    // Update Assignment
    updateAssignment: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/${id}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["Assignment"],
    }),

    // Delete Assignment
    deleteAssignment: builder.mutation({
      query: ({ id }) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Assignment"],
    }),
  }),
});

export const {
  useCreateAssignmentMutation,
  useGetAssignmentsQuery,
  useUpdateAssignmentMutation,
  useDeleteAssignmentMutation,
} = assignmentApi;
